//import "babel-polyfill";
import * as React from "react";
import {Provider} from 'mobx-react'
import {StaticRouter} from "react-router";
import {Router as BrowserRouter, Route} from "react-router-dom";
import {observer} from "mobx-react";
import {ToastContainer} from 'react-toastify';
//import Progress from 'react-progress-2';
import {createBrowserHistory, createMemoryHistory} from 'history';
//import { RouterModel, syncHistoryWithStore } from 'mst-react-router';

import ReactResizeDetector from 'react-resize-detector';
import debounce from '@utils/debounce';
import TagManager from 'react-gtm-module'
import {Helmet} from "react-helmet";


// Implementation specifics
import TemplateRenderer from '@templates/templaterenderer';
import {ProductModal} from '@components/Products/ProductDetails';
import SiteSettingsPortal from "./navigation/SiteSettingsPortal";


//import myPagesTree from "@components/navigation/mypages";
import Store from "./StoreConfiguration";
import {RouterModel} from "@stores/Router";
import {syncHistoryWithStore} from "@stores/Sync";
// Fontawesome>
import {library} from '@fortawesome/fontawesome-svg-core'

import {faShoppingBag} from '@fortawesome/free-solid-svg-icons/faShoppingBag'
import {faShoppingCart} from '@fortawesome/free-solid-svg-icons/faShoppingCart'
import {faSearch} from '@fortawesome/free-solid-svg-icons/faSearch'
import {faBars} from '@fortawesome/free-solid-svg-icons/faBars'
import {faTimes} from '@fortawesome/free-solid-svg-icons/faTimes'
import {faTrash} from '@fortawesome/free-solid-svg-icons/faTrash'
import {faAngleRight} from '@fortawesome/free-solid-svg-icons/faAngleRight'
import {faAngleLeft} from '@fortawesome/free-solid-svg-icons/faAngleLeft'
import {faAngleDown} from '@fortawesome/free-solid-svg-icons/faAngleDown'
import {faAngleUp} from '@fortawesome/free-solid-svg-icons/faAngleUp'
import {faCheckCircle} from '@fortawesome/free-solid-svg-icons/faCheckCircle'
import {faTimesCircle} from '@fortawesome/free-regular-svg-icons/faTimesCircle'
import {faSadTear} from '@fortawesome/free-regular-svg-icons/faSadTear'
import {faPlusCircle} from '@fortawesome/free-solid-svg-icons/faPlusCircle'
import {faMinusCircle} from '@fortawesome/free-solid-svg-icons/faMinusCircle'
import {faFilter} from '@fortawesome/free-solid-svg-icons/faFilter'
import {faCircle} from '@fortawesome/free-regular-svg-icons/faCircle'
import {faDotCircle} from '@fortawesome/free-regular-svg-icons/faDotCircle'
import {faSpinner} from '@fortawesome/free-solid-svg-icons/faSpinner'
import {faExternalLinkAlt} from "@fortawesome/free-solid-svg-icons/faExternalLinkAlt"
import {faWindowClose} from '@fortawesome/free-solid-svg-icons/faWindowClose'
import {faUser} from '@fortawesome/free-solid-svg-icons/faUser'
import {faPlusSquare} from '@fortawesome/free-regular-svg-icons/faPlusSquare'
import {faMinusSquare} from '@fortawesome/free-regular-svg-icons/faMinusSquare'
import {faHeart as faHeartRegular} from '@fortawesome/free-regular-svg-icons/faHeart'
import {faHeart as faHeartSolid} from '@fortawesome/free-solid-svg-icons/faHeart'
import {faQuestionCircle} from "@fortawesome/free-regular-svg-icons/faQuestionCircle"
import {faPlus} from '@fortawesome/free-solid-svg-icons/faPlus'
import {faMinus} from '@fortawesome/free-solid-svg-icons/faMinus'
import {faChevronRight} from '@fortawesome/free-solid-svg-icons/faChevronRight'
import {faChevronLeft} from '@fortawesome/free-solid-svg-icons/faChevronLeft'

global.Helmet = Helmet;

@observer
class App extends React.Component {
    constructor(props) {
        super(props);

        const tagManagerArgs = {
            gtmId: props.gtmKey // from marketSettings
        }


        this.onResize = debounce(this.onResize.bind(this), 100);
        this.updateViewPortWidth = this.updateViewPortWidth.bind(this);
        this.handleUrl = this.handleUrl.bind(this);

        const countdown = props.marketSettings !== undefined ? props.marketSettings.CountdownData : {};

        // Server?
        const serverRender = typeof window === 'undefined';

        this.mainRouter = RouterModel.create({name: "mainRouter"});
        this.hashRouter = RouterModel.create({name: "hashRouter"});

        this.toolbarRouter = serverRender ? {} : RouterModel.create({name: "toolbarRouter"});

        // Mobs-State-Tree store
        this.store = Store.create({
            account: props.accountData,
            navigation: {
                baseUrl: this.props.baseUrl,
                mainRouter: this.mainRouter,
                hashRouter: this.hashRouter,
                initialUrl: props.initialUrl,
                CurrentUrl: props.initialUrl,
                toolbarRouter: this.toolbarRouter,
                serverLocation: this.props.location,
                siteTree: props.siteData,
                mainTree: {...props.navigationData, Countries: props.contentData.Countries},
                myPagesTree: this.props.myPagesData,
                //myPagesTree: myPagesTree(),
                marketSettings: this.props.marketSettings,

                products: props.contentData.Products || [],
                totalResults: props.contentData.TotalResults || 0,
                contentProducts: props.contentData.ContentProducts || [],
                singleProduct: props.singleProduct,
                facets: props.contentData.Facets || [],


                NodeId: props.contentData.Id,
                TemplateAlias: props.contentData.TemplateAlias,
                SiteId: props.contentData.SiteId,
                NodePath: props.contentData.NodePath,
                CultureCode: props.contentData.CultureCode,
                MarketCode: props.marketCode, // controller -> master page -> app
                CountryCode: props.countryCode, // controller -> master page -> app
                LanguageCode: props.languageCode, // controller -> master page -> app


                pageContent: props.contentData,
                footerContent: props.footerData,
                countdownContent: countdown,
                ticker: props.tickerData,
                definitions: props.definitions,
                dataTypes: props.dataTypes,
                colors: props.colors,
                sizeInformationCollection: props.sizeInformationCollection,
                dictionary: props.dictionary,
                isMobile: props.isMobile,
                isBot: props.isBot,
                viewPortWidth: (props.isMobile || props.isBot) ? 368 : 1440,
                mainSkinColor: props.mainSkinColor,
                recaptchaV2Key: props.recaptchaV2Key,
                SSR_CustomerId: props.customerId
            }
            //order: {
            //    Basket: props.basketData.Basket
            //}
        });

        if (!serverRender) {
            // console-purposes..
            console.debug("Init tag-manager", tagManagerArgs);
            TagManager.initialize(tagManagerArgs);


            window.store = this.store;
            this.detectTouch();
        }

        this.mainHistory = serverRender ? null : createBrowserHistory();
        this.toolbarHistory = serverRender ? null : createMemoryHistory(); //{ hashType: "noslash" }

        if (!serverRender) {
            this.toolbarHistory.location.key = new Date().getTime();
            //this.toolbarRouter.location.key = this.toolbarHistory.location.key;
        }

        //history object
        this.mstMainHistory = syncHistoryWithStore(this.mainHistory, this.mainRouter, this.props.location);
        //this.mstHashHistory = serverRender ? null : syncHistoryWithStore(this.hashHistory, this.hashRouter);
        this.mstToolbarHistory = serverRender ? null : syncHistoryWithStore(this.toolbarHistory, this.toolbarRouter);


        //// Bind external items to navigation-store.
        if (!serverRender) {
            this.store.navigation.setMstToolbarHistory(this.mstToolbarHistory);
            this.store.navigation.setMstMainHistory(this.mstMainHistory);
            //            this.store.navigation.setProgress(Progress);
            this.store.navigation.activateUrlAndCustomerListener();
        }

        library.add(faShoppingBag, faShoppingCart, faSearch, faBars, faTimes, faAngleLeft, faAngleRight, faCheckCircle,
            faTimesCircle, faSadTear, faPlusCircle, faMinusCircle, faFilter, faCircle, faDotCircle, faSpinner, faExternalLinkAlt, faTrash, faWindowClose, faUser, faPlusSquare, faMinusSquare, faHeartRegular, faHeartSolid, faQuestionCircle, faPlus, faMinus, faAngleDown, faAngleUp, faChevronRight, faChevronLeft);

    }


    detectTouch() {
        if (typeof window !== 'undefined') {
            window.addEventListener('touchstart',
                function onFirstTouch() {
                    // we could use a class
                    //document.body.classList.add('user-is-touching');
                    window.store.navigation.setTouchEnabled();

                    // or set some global variable
                    console.debug("USER IS TOUCHING!");

                    // we only need to know once that a human touched the screen, so we can stop listening now
                    window.removeEventListener('touchstart', onFirstTouch, false);
                },
                false);
        }
    }

    componentDidMount() {
        if (typeof window !== 'undefined') {

            this.updateViewPortWidth(window.innerWidth);
        }
    }

    onResize(w, h) {
        //console.debug("onResize", w);
        this.updateViewPortWidth(window.innerWidth);
    }

    isMobileViewPortWidth() {
        if (typeof window !== 'undefined') {
            const scrollbarWidth = 16;
            return (window.innerWidth < (769 - scrollbarWidth));
        }

        return true;
    }

    updateViewPortWidth(w) {
        this.store.navigation.setViewPortWidth(w);
        const scrollbarWidth = 0;
        //console.debug("current width", w);
        //const currentWidth = (767 - scrollbarWidth);
        if (w <= (1200 - scrollbarWidth) && !this.store.navigation.isMobile) {
            this.store.navigation.setIsMobile(true);
            console.debug("setMobile true");
        } else if (w > (1200 - scrollbarWidth) && this.store.navigation.isMobile) {
            this.store.navigation.setIsMobile(false);
            console.debug("setMobile false");
        }
    }

    handleUrl(url) {
        let target = "/start";
        let result = url;
        if (result.endsWith(target)) {
            result = result.substring(0, url.indexOf(target));
        }

        return result;
    }

    render() {


        const navigation = this.store.navigation;
        let renderXDefault = false;

        // var location = typeof window === 'undefined'
        //     ? this.props.location
        //     : navigation.mainRouter.location;

        return [

            <Helmet key={"helmet"}>
                <title>{this.store.navigation.pageContent.Title}</title>
                <meta name="keywords" content={this.store.navigation.pageContent.Properties.seoKeywords}/>
                <meta name="description" content={this.store.navigation.pageContent.Properties.seoDescription}/>
                <meta property="og:title" content={this.store.navigation.pageContent.Title}/>
                {this.store.navigation.pageContent.Properties.seoImage &&
                    <meta property="og:image" content={this.store.navigation.baseUrl + this.store.navigation.pageContent.Properties.seoImage}/>}
                <meta property="og:description" content={this.store.navigation.pageContent.Properties.seoDescription}/>

                {this.store.navigation.pageContent.Properties.seoNoIndex &&
                    <meta name="robots" content="noindex"/>
                }

                {this.store.navigation.mainTree.Countries.map((country) => {
                    return (
                        country.LanguageUrls.map(languageUrl => {
                            const items = [];

                            // Canonical
                            if (country.CountryCode === navigation.CountryCode &&
                                languageUrl.LanguageCode === navigation.LanguageCode) {

                                // if start page, set cananical to site url
                                if (this.store.navigation.pageContent.Name === "Start") {
                                    items.push(<link rel="canonical" href={this.store.navigation.baseUrl}/>);
                                    items.push(<meta property='og:url' content={this.store.navigation.baseUrl}/>);
                                } else {
                                    items.push(<link rel="canonical" href={languageUrl.BaseUrl()}/>);
                                    items.push(<meta property='og:url' content={languageUrl.BaseUrl()}/>);
                                }
                            }

                            // Country defaults and alternatives
                            if (languageUrl && languageUrl.LanguageDefault && languageUrl.LanguageCode === navigation.LanguageCode) {

                                if (!renderXDefault) {
                                    if (this.store.navigation.pageContent.Name.toLowerCase() === "start") {
                                        items.push(<link rel="alternate" hreflang="x-default" href={this.store.navigation.baseUrl + "/en-eu"}/>);
                                    } else {
                                        items.push(<link rel="alternate" hreflang="x-default" href={this.handleUrl(languageUrl.BaseUrl())}/>);
                                    }
                                    renderXDefault = true;
                                }
                                items.push(<link rel="alternate" hreflang={languageUrl.LanguageCode} href={this.handleUrl(languageUrl.BaseUrl())}/>);
                                items.push(
                                    <link rel="alternate" hreflang={languageUrl.HrefLang} href={this.handleUrl(languageUrl.BaseUrl())}
                                          dataTemp={this.handleUrl(languageUrl.Url)}/>);

                            } else {
                                items.push(
                                    <link rel="alternate" hreflang={languageUrl.HrefLang} href={this.handleUrl(languageUrl.BaseUrl())}/>);

                            }
                            return (items);
                        }));
                })
                }


            </Helmet>,
            <Provider key="provider" 
                      store={this.store}>
                    {typeof window === 'undefined'
                        ? <StaticRouter
                            context={this.props.context}
                            location={this.props.location}
                        >
                            <SiteSettingsPortal
                                key={"siteSettingsPortal"}
                            >
                                <Route
                                    path={navigation.mainTree.SearchUrl + "/p/*"}
                                    location={navigation.mainRouter.location}
                                    render={({match, location}) => {
                                        return (
                                            <ProductModal/>
                                        );
                                    }}/>
                                <TemplateRenderer
                                    key={"templateRender" + navigation.getCustomerId()}
                                    navigation={this.store.navigation}
                                    serverLocation={this.props.location}
                                />

                                <ReactResizeDetector handleWidth onResize={this.onResize}/>
                                <ToastContainer
                                    position="bottom-right"
                                    limit={3}
                                    autoClose={2500}
                                    hideProgressBar={false}
                                    newestOnTop={true}
                                    closeOnClick
                                    pauseOnFocusLoss
                                    draggable
                                    pauseOnHover
                                    theme="dark"
                                />
                            </SiteSettingsPortal>
                        </StaticRouter>
                        : <BrowserRouter className="router" history={this.mstMainHistory}>
                            <SiteSettingsPortal
                                key={"siteSettingsPortal"}
                            >
                                <Route
                                    path={navigation.mainTree.SearchUrl + "/p/*"}
                                    location={navigation.mainRouter.location}
                                    render={({match, location}) => {
                                        return (
                                            <ProductModal/>
                                        );
                                    }}/>
                                <TemplateRenderer
                                    key={"templateRender"}
                                    //key={"templateRender" + navigation.getCustomerId()}
                                    navigation={this.store.navigation}
                                    serverLocation={null}
                                />

                                <ReactResizeDetector handleWidth onResize={this.onResize}/>
                                <ToastContainer
                                    position="bottom-right"
                                    limit={3}
                                    autoClose={2500}
                                    hideProgressBar={false}
                                    newestOnTop={true}
                                    closeOnClick
                                    pauseOnFocusLoss
                                    draggable
                                    pauseOnHover
                                    theme="dark"
                                />
                               
                            </SiteSettingsPortal>
                            
                        </BrowserRouter>

                    }

                
            </Provider>

        ];
    }
}


export default App;

